// Styles
import './Option.scss';

// Libs
import React, { useCallback, useMemo } from 'react';

// Assets
import { ReactComponent as FavoriteSvg } from '@/materiaux/assets/icons/favorite-active.svg';

import { OptionDefaultProps, OptionPropTypes } from './Option.proptypes';

const Option = ({
  active,
  className,
  count,
  disabled,
  name,
  onChange,
  title,
  value,
}) => {
  const getLabel = useMemo(
    () => (
      <>
        {`${title} (${count})`}
        {active && <FavoriteSvg className="select-group-option__icon" />}
      </>
    ),
    [active, count, title],
  );

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () =>
      [
        'select-group-option',
        active || disabled ? 'select-group-option--disabled' : null,
        count === 0 ? 'select-group-option--empty' : null,
        className,
      ]
        .filter((val) => val)
        .join(' '),
    [className, count, active, disabled],
  );

  /**
   * On change handler
   * @param {event} e
   */
  const handleChange = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onChange(e, title);
    },
    [onChange, title],
  );

  return (
    <button
      className={classNames}
      disabled={active || disabled}
      name={name}
      onClick={handleChange}
      onKeyPress={handleChange}
      type="button"
      value={value}
    >
      {getLabel}
    </button>
  );
};

Option.defaultProps = {
  ...OptionDefaultProps,
};

Option.propTypes = {
  ...OptionPropTypes,
};

export default Option;
